(function () {
  var STORAGE_KEY = 'lipsell_wishlist';

  var storage = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { return []; }
    },
    set: function (items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
    }
  };

  window.Wishlist = {
    getItems: function () { return storage.get(); },

    has: function (productId) {
      return storage.get().some(function (i) { return i.id === productId; });
    },

    add: function (product) {
      var items = storage.get();
      if (!items.some(function (i) { return i.id === product.id; })) {
        items.push(product);
        storage.set(items);
      }
    },

    remove: function (productId) {
      storage.set(storage.get().filter(function (i) { return i.id !== productId; }));
    },

    toggle: function (product) {
      this.has(product.id) ? this.remove(product.id) : this.add(product);
    },

    count: function () { return storage.get().length; }
  };

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var id = parseInt(btn.dataset.wishlistBtn);
      var active = window.Wishlist.has(id);
      btn.classList.toggle('wishlist-btn--active', active);
      btn.setAttribute('aria-pressed', String(active));
      btn.title = active ? (btn.dataset.labelRemove || '') : (btn.dataset.labelAdd || '');
    });
  }

  function syncCounter() {
    var count = window.Wishlist.count();
    document.querySelectorAll('.wishlist-total-count').forEach(function (el) {
      el.textContent = count;
      el.dataset.total = count;
    });
  }

  var wToast, wToastTimer;
  var lastCount = window.Wishlist.count();

  function showWishToast(msg) {
    if (!wToast) return;
    wToast.textContent = msg;
    clearTimeout(wToastTimer);
    wToast.classList.add('is-visible');
    wToastTimer = setTimeout(function () { wToast.classList.remove('is-visible'); }, 2000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var product = {
      id: parseInt(btn.dataset.wishlistBtn),
      handle: btn.dataset.handle || '',
      title: btn.dataset.title || '',
      url: btn.dataset.url || '',
      price: parseInt(btn.dataset.price || '0'),
      image: btn.dataset.image || '',
      vendor: btn.dataset.vendor || '',
      subtitle: btn.dataset.subtitle || '',
      rrp: btn.dataset.rrp || '',
      lowestPrice: btn.dataset.lowestPrice || ''
    };

    window.Wishlist.toggle(product);
  });

  // Toast on both add and remove — count delta covers card buttons AND the wishlist-page remove button
  document.addEventListener('wishlist:updated', function (e) {
    syncButtons();
    syncCounter();
    var newCount = (e.detail && e.detail.items) ? e.detail.items.length : window.Wishlist.count();
    if (newCount > lastCount) {
      showWishToast('✓ ' + ((window.languages && window.languages.productAddedShort) || 'Pridėta!'));
    } else if (newCount < lastCount) {
      showWishToast((window.languages && window.languages.wishlistRemoved) || 'Pašalinta!');
    }
    lastCount = newCount;
  });

  // Re-sync after cart/section re-renders reset the counter DOM
  document.addEventListener('cart:rerendered', syncCounter);
  document.addEventListener('page:loaded', syncCounter);

  var counterObserver = new MutationObserver(function () {
    var els = document.querySelectorAll('.wishlist-total-count');
    if (!els.length) return;
    var count = window.Wishlist.count();
    els.forEach(function (el) {
      if (parseInt(el.dataset.total) !== count) {
        el.textContent = count;
        el.dataset.total = count;
      }
    });
  });
  counterObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons();
    syncCounter();

    wToast = document.createElement('div');
    wToast.id = 'ls-wishlist-toast';
    wToast.textContent = '✓ ' + ((window.languages && window.languages.productAddedShort) || 'Pridėta');
    document.body.appendChild(wToast);

    var s = document.createElement('style');
    s.textContent = '#ls-wishlist-toast{'
      + 'position:fixed;bottom:90px;left:50%;'
      + 'transform:translateX(-50%) translateY(12px);'
      + 'background:#1a1b1e;color:#fff;'
      + 'padding:10px 20px;border-radius:24px;'
      + 'font-size:14px;font-family:inherit;'
      + 'white-space:nowrap;opacity:0;'
      + 'transition:opacity .22s ease,transform .22s ease;'
      + 'pointer-events:none;z-index:350;}'
      + '#ls-wishlist-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0);}'
      + '@media(min-width:1000px){#ls-wishlist-toast{bottom:30px;}}';
    document.head.appendChild(s);
  });
})();
